import React from 'react';
import { DialogContent, DialogTitle, Grid, Typography, useTheme, Chip, useMediaQuery } from '@mui/material';
import { RoundedDialog, StandardDialogActions, PicturesCarousel } from '../../../Global/Components';
import { AddCircleOutlineRounded, LockRounded } from '@mui/icons-material';
import { FormIcon, ProcessIcon, RegistersIcon, TaskIcon, AuditIcon } from '../../../Global/Icons';
import { isEmpty, isArray } from 'lodash';
import { useHistory } from 'react-router-dom';

export default function ResourceDialog({ open, onClose, resource }) {
  const theme = useTheme();
  const history = useHistory();
  const loggedIn = Boolean(localStorage.getItem('token') && localStorage.getItem('_id'));
  const largeDevices = useMediaQuery(theme.breakpoints.up('sm'));
  if (!resource) return null;

  function addResource() {
    if (resource.type === 'form') {
      history.push(`/forms/form-builder/resource/${resource._id}`);
    }
    if (resource.type === 'process') {
      history.push(`/processes/process-builder/resource/${resource._id}`);
    }
    if (resource.type === 'register') {
      history.push(`/registers/new-register/${resource._id}`);
    }
    if (resource.type === 'task') {
      history.push(`/tasks/templates/resource/${resource._id}`);
    }
    if (resource.type === 'requirements') {
      history.push(`/audits/requirement-builder/resource/${resource._id}`);
    }
  }

  function signUp() {
    history.push('/login');
  }

  return (
    <RoundedDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className={'light-scroll-bar'}
      fullScreen={!largeDevices}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>{resource.title}</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2}>
          {resource.type === 'form' && (
            <Grid container item alignItems="center">
              <FormIcon />
              <Typography style={{ marginLeft: '0.75em' }} variant="h6">
                Form
              </Typography>
            </Grid>
          )}
          {resource.type === 'process' && (
            <Grid container item alignItems="center">
              <ProcessIcon />
              <Typography style={{ marginLeft: '0.75em' }} variant="h6">
                Process
              </Typography>
            </Grid>
          )}
          {resource.type === 'register' && (
            <Grid container item alignItems="center">
              <RegistersIcon />
              <Typography style={{ marginLeft: '0.75em' }} variant="h6">
                Register
              </Typography>
            </Grid>
          )}
          {resource.type === 'task' && (
            <Grid container item alignItems="center">
              <TaskIcon />
              <Typography style={{ marginLeft: '0.75em' }} variant="h6">
                Task template
              </Typography>
            </Grid>
          )}
          {resource.type === 'requirements' && (
            <Grid container item alignItems="center">
              <AuditIcon />
              <Typography style={{ marginLeft: '0.75em' }} variant="h6">
                Audit requirements
              </Typography>
            </Grid>
          )}
          {isArray(resource.tags) && !isEmpty(resource.tags) && (
            <Grid container item>
              {resource.tags.map((tag) => (
                <Chip
                  key={tag._id}
                  label={tag.text}
                  style={{
                    background: tag.color,
                    color: theme.palette.getContrastText(tag.color),
                    margin: 5,
                  }}
                />
              ))}
            </Grid>
          )}
          <Grid container item dangerouslySetInnerHTML={{ __html: resource.description }} />

          {isArray(resource.pictures) && resource.pictures.length > 1 && (
            <Grid container item alignItems="center">
              <PicturesCarousel large pictures={resource.pictures.slice(1)} minHeight="45vh" />
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <StandardDialogActions
        onClose={onClose}
        doneButtonIcon={loggedIn ? <AddCircleOutlineRounded /> : <LockRounded />}
        onDone={loggedIn ? addResource : signUp}
        doneButtonText={loggedIn ? `add ${resource.type}` : `log in and add ${resource.type}`}
      />
    </RoundedDialog>
  );
}
